/* global globalThis */
// Browser polyfills — must load before any other app code.
//
// @react-pdf/renderer (via @react-pdf/fontkit + pdfkit) references the Node
// `Buffer` global while embedding/subsetting fonts at render time. CRA 5 /
// webpack 5 no longer injects Node polyfills automatically, so the production
// bundle throws "Buffer is not defined" the moment a PDF is rendered. The
// error is swallowed by @react-pdf, which then falls back to an unshaped
// render: Arabic certificates come out as disconnected, garbled glyphs (the
// fonts fetch fine, they just never get embedded). Providing Buffer globally
// makes the certificate + report PDFs render identically to the dev server.
import { Buffer } from 'buffer';

const g =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof window !== 'undefined' && window) ||
  null;

if (g && !g.Buffer) {
  g.Buffer = Buffer;
}
